<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>数据字典</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <collapse @getDataList="search">
        <collapse-item>
          <span>关键字</span>
          <el-input placeholder="名称、编码" v-model="queryInfoparams.params.keyword" clearable @clear='queryInfoparams.params.keyword=null' @change="search"></el-input>
        </collapse-item>


        <collapse-item>
          <span>状态</span>    
          <el-select v-model="queryInfoparams.params.status" placeholder="请选择" clearable @clear='clearStatus' @change="search">
            <el-option label="生效" value="Y"></el-option>
            <el-option label="失效" value="N"></el-option>
          </el-select> 
        </collapse-item>
      </collapse>

      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button
              plain
              size="small"
              icon="el-icon-plus"
              @click="showAddDialog"
              v-hasPermission="['dict:save']"
              >新增</el-button
            >

            <el-button
              plain
              size="small"
              icon="el-icon-delete"
              @click="deletes"
              v-hasPermission="['dict:delete']"
              >删除</el-button
            >
          </el-button-group>
        </el-col>
      </el-row>

      <!-- 列表区域 -->
      <el-table
        :data="dataList"
        border
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="名称" sortable="custom" prop="typeName"></el-table-column>
        <el-table-column label="编码" sortable="custom" prop="typeCode"></el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 'Y'" type="success">生效</el-tag>
            <el-tag v-else-if="scope.row.status === 'N'" type="info">失效</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="180px">
          <template  slot-scope="scope">
            <el-link icon="el-icon-edit" @click="showEditDialog(scope.row.id)">编辑</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link icon="el-icon-s-setting" @click="setItem(scope.row)" >明细</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="编辑数据字典"
      :visible.sync="dialogVisible"
      width="50%"
      @close="dialogClosed"
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="editFormRef"
        label-width="70px"
      >
        <el-form-item label="名称" prop="typeName" label-width="100px">
          <el-input v-model="addForm.typeName"></el-input>
        </el-form-item>

        <el-form-item label="编码" prop="typeCode" label-width="100px">
          <el-input v-model="addForm.typeCode"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark" label-width="100px">
          <el-input v-model="addForm.remark"></el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status" label-width="100px">
          <el-radio-group v-model="addForm.status">
            <el-radio label="Y">生效</el-radio>
            <el-radio label="N">失效</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse.vue'
import CollapseItem from '@/components/collapse/CollapseItem.vue'
export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      // 获取列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },

      // 列表
      dataList: [],
      total: 0,

      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,

      // 添加和修改用户的表单数据
      addForm: {
        status: 'Y',
      },

      // 添加表单的验证规则对象
      addFormRules: {
        typeName: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
        ],
        typeCode: [
          { required: true, message: '编码不能为空', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' },
        ],
      },

      // 控制修改 对话框的显示与隐藏
      dialogVisible: false,

      // 查询到的信息
      editForm: {},

      //checkbox选择的只
      multipleSelection: [],
    }
  },
  methods: {
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    // 获取 查询用户数据列表
    getDataList() {
      console.log(this.queryInfoparams);
    // 分页查询用户
      this.$post('dict/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
        }
      )
    },

    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order
      this.getDataList()
    },

    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },

    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },

    // 展示新增的对话框
    showAddDialog(id) {
      this.addForm.status = 'Y'
      this.dialogVisible = true
    },

      // 展示编辑的对话框
    showEditDialog(id) {
      this.dialogVisible = true

      this.$get(`dict/get/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm = res.data

      })
    },
     // 跳转
    setItem(record) {
      

      this.$router.push({path: '/dict/dictItem', query: {typeId: record.id,typeName:record.typeName}})
    },

    // 监听添加用户对话框的关闭事件
    dialogClosed() {
      this.addForm = {}
      this.$refs.editFormRef.resetFields()
    },
  clearStatus(){
    this.queryInfoparams.params.status==null
  },
    // 点击按钮保存
    save() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.$post('dict/save', this.addForm).then(({ data: res }) => {
          if (res.ok) {
            // 隐藏添加的对话框
            this.dialogVisible = false
            // 刷新列表数据
            this.search()
            this.dialogClosed()
            return this.$message.success('添加成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },

    // 批量删除
   async deletes() {

      console.log('multipleSelection',this.multipleSelection)
       console.log('multipleSelection',this.multipleSelection.length)
      if (this.multipleSelection == null || this.multipleSelection.length <= 0) {
        return this.$message.error('请先勾选要删除的数据')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)


     const confirmResult = await this.$confirm(
        '此操作将永久删除, 是否继续?',
        '删除树',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).then(() => {
          this.$delete(`dict/batchDelete`, { idList: ids }).then(
            ({ data: res }) => {
              if (! res.ok ) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.search()
            }
          )
        }).catch(() =>{
          
        })



     
    },
  },
  mounted() {
    this.search()
  },
}
</script>

<style lang='less' scoped>
.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
</style>